import {
  FETCH_DATA_ENTITIES_REQUEST,
  FETCH_DATA_ENTITIES_SUCCESS,
  FETCH_DATA_ENTITIES_FAILURE,
} from "../../actions/entities/get-entities-action";

const initialState = {
  list: [],
  isLoading: false,
  error: null,
};

const EntitiesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_DATA_ENTITIES_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_DATA_ENTITIES_SUCCESS:
      console.log("payload", action.payload);
      return {
        ...state,
        isLoading: false,
        list: action.payload.values,
        meta: action.payload.meta,
      };
    case FETCH_DATA_ENTITIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default EntitiesReducer;
